<div class="data-table-wrapper">
    <!-- Search Box -->
    <div class="mb-3" *ngIf="config.searchable">
        <div class="input-group">
            <span class="input-group-text bg-white">
                <i class="bi bi-search"></i>
            </span>
            <input type="text" class="form-control search-box" placeholder="Search..." [(ngModel)]="searchTerm"
                (input)="onSearch(searchTerm)">
            <button *ngIf="searchTerm" class="btn btn-outline-secondary" (click)="clearSearch()" type="button">
                <i class="bi bi-x"></i>
            </button>
        </div>
    </div>

    <!-- Table Container -->
    <div class="data-table-container" [class.table-responsive]="config.responsive">
        <table [class]="getTableClasses()">
            <!-- Table Head -->
            <thead>
                <tr *ngIf="!isMobile">
                    <th *ngFor="let column of columns" [class]="getSortClass(column) + ' ' + (column.class || '')"
                        (click)="onSort(column)">
                        {{ column.label }}
                    </th>
                </tr>
                <tr *ngIf="isMobile">
                    <th class="mobile-combined-header">
                        <div class="mobile-transaction-header-row">
                            <div class="header-col-name">Transaction Details</div>
                            <div class="sort-button" (click)="toggleSortDropdown($event)">
                                <span class="sort-label"></span>
                                <span class="active-indicator" *ngIf="sortConfig.column">•</span>
                            </div>
                        </div>

                        <!-- Sort Dropdown Modal -->
                        <div class="sort-dropdown" *ngIf="showSortDropdown" (click)="$event.stopPropagation()">
                            <div class="sort-dropdown-header">
                                <span>Sort By</span>
                            </div>
                            <div class="sort-dropdown-options">
                                <div *ngFor="let column of columns" class="sort-option"
                                    [class.active]="isSorted(column.key)" (click)="onSortByKey(column.key)"
                                    [hidden]="!column.label">
                                    <div class="sort-option-content">
                                        <span class="sort-option-label">{{ column.label }}</span>
                                        <span class="sort-direction" *ngIf="isSorted(column.key)">
                                            <span *ngIf="getSortDirection(column.key) === 'asc'">↑</span>
                                            <span *ngIf="getSortDirection(column.key) === 'desc'">↓</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Backdrop -->
                        <div class="sort-dropdown-backdrop" *ngIf="showSortDropdown" (click)="closeSortDropdown()">
                        </div>
                    </th>
                    <th class="mobile-balance-header" *ngIf="hasColumn(mobileSeparateColumn)">
                        {{ getColumn(mobileSeparateColumn)?.label }}
                    </th>
                </tr>
            </thead>
        </table>
        <table [class]="getTableClasses()" class="second-table-with-tbody">
            <!-- Table Body -->
            <tbody>
                <!-- Loading State -->
                <tr *ngIf="loading">
                    <td [attr.colspan]="isMobile ? (hasColumn(mobileSeparateColumn) ? 2 : 1) : columns.length"
                        class="table-loading">
                        <div class="spinner-container">
                            <div class="spinner"></div>
                            <p>Loading transactions...</p>
                        </div>
                    </td>
                </tr>

                <!-- Empty State -->
                <tr *ngIf="!loading && paginatedData.length === 0">
                    <td [attr.colspan]="isMobile ? (hasColumn(mobileSeparateColumn) ? 2 : 1) : columns.length"
                        class="table-empty">
                        <i class="bi bi-inbox"></i>
                        <p>No transactions found</p>
                    </td>
                </tr>

                <tr *ngFor="let row of paginatedData" (click)="onRowClick(row)"
                    [class.cursor-pointer]="rowClick.observed">
                    <!-- Desktop View -->
                    <ng-container *ngIf="!isMobile">
                        <td *ngFor="let column of columns" [class]="column.class"
                            [innerHTML]="getCellContent(column, row)">
                        </td>
                    </ng-container>

                    <!-- Mobile View -->
                    <ng-container *ngIf="isMobile">
                        <td class="mobile-combined-cell">
                            <div class="mobile-card-content">
                                <ng-container *ngFor="let column of columns">
                                    <div *ngIf="column.key !== mobileSeparateColumn"
                                        [class]="'mobile-col-' + column.key" [innerHTML]="getCellContent(column, row)">
                                    </div>
                                </ng-container>
                            </div>
                        </td>
                        <td *ngIf="hasColumn(mobileSeparateColumn)" class="mobile-balance-cell">
                            <div class="mobile-card-content"
                                [innerHTML]="getCellContent(getColumn(mobileSeparateColumn)!, row)"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <!-- <div class="pagination-container" *ngIf="config.paginated && paginationConfig.totalPages > 1">
        <div class="pagination-info">
            Showing {{ (paginationConfig.currentPage - 1) * paginationConfig.itemsPerPage + 1 }}
            to {{ Math.min(paginationConfig.currentPage * paginationConfig.itemsPerPage, paginationConfig.totalItems) }}
            of {{ paginationConfig.totalItems }} entries
        </div>

        <div class="pagination-controls">
            <button class="pagination-btn" (click)="previousPage()" [disabled]="paginationConfig.currentPage === 1">
                <i class="bi bi-chevron-left"></i>
            </button>

            <button *ngFor="let page of getPageNumbers()" class="pagination-btn"
                [class.active]="page === paginationConfig.currentPage" [disabled]="page === '...'"
                (click)="page !== '...' && typeof page === 'number' && goToPage(page)">
                {{ page }}
            </button>

            <button class="pagination-btn" (click)="nextPage()"
                [disabled]="paginationConfig.currentPage === paginationConfig.totalPages">
                <i class="bi bi-chevron-right"></i>
            </button>
        </div>
    </div> -->
</div>